(function () {
  'use strict';

  /**
   * @ngdoc object
   *
   *
   * @description
   *
   */
  angular
    .module('crewProfile')
    .controller('CrewACMIopsHistoryController', CrewACMIopsHistoryController);

  function CrewACMIopsHistoryController($uibModalInstance, modalParams, ProfileService) {
    var vm = this;

    vm.model = {
      acmiOperationsList : []
    };

    function getCrewACMIData() {
      var param = {};
      param.crewProfileId = modalParams.crewProfileId;
      param.onlyEffectiveRanges = modalParams.onlyEffectiveRanges;
      ProfileService.getCrewAcmiHistoryData(param,
        function (response) {
          vm.model.acmiOperationsList = response;
        },
        function (error) {
          console.log('Crew base assignment data retrieval error')
        }
      );
    }

    vm.closeMe = function () {
      $uibModalInstance.close();
    };

    getCrewACMIData();
  }
}());
